import { gql } from "@apollo/client"
import { VENDOR_DETAIL_FRAG } from "./vendor.fragments.gql"

export const ADD_UPDATE_VENDOR = gql`
  mutation AddUpdateVendor(
    $deleteKycIds: [ID]
    $address: AddressInput!
    $dateOfBirth: Date
    $education: BaseUserEducationEnum
    $email: String
    $firstName: String!
    $gender: BaseUserGenderEnum
    $groups: [ID]
    $id: ID
    $kycDetail: [KYCDetailInput]
    $lastName: String!
    $number: String!
    $referenceId: String
    $businessName: String
    $businessId: ID
    $username: String!
  ) {
    addUpdateVendor(
      address: $address
      dateOfBirth: $dateOfBirth
      education: $education
      email: $email
      firstName: $firstName
      gender: $gender
      groups: $groups
      id: $id
      kycDetails: $kycDetail
      lastName: $lastName
      number: $number
      referenceId: $referenceId
      businessName: $businessName
      businessId: $businessId
      username: $username
      deleteKycIds: $deleteKycIds
    ) {
      user {
        ...VendorDetailFrag
      }
    }
  }
  ${VENDOR_DETAIL_FRAG}
`

export const BULK_UPDATE_USERS = gql`
  mutation bulkUpdateVendors($userIds: [ID!]!, $status: String!) {
    bulkUpdateUsers(userIds: $userIds, status: $status) {
      users {
        id
        status
        statusObj @client {
          id
          intent
          name
        }
      }
    }
  }
`

export const ADD_UPDATE_USER_CREDIT = gql`
  mutation AddUpdateUserCredit(
    $id: ID
    $userId: ID!
    $totalAmount: Float!
    $paymentCycleDays: Int
    $startDate: Date
    $endDate: Date
    $isActive: Boolean
    $status: String
  ) {
    addUpdateCredit(
      id: $id
      userId: $userId
      totalAmount: $totalAmount
      paymentCycleDays: $paymentCycleDays
      startDate: $startDate
      endDate: $endDate
      isActive: $isActive
      status: $status
    ) {
      credit {
        id
        totalAmount
        remainingAmount
        usedAmount
        paymentCycleDays
        startDate
        endDate
        isActive
        status
        user {
          id
          firstName
        }
      }
    }
  }
`
